
import React from 'react';
import { Link } from 'react-router-dom';
import { Music, Mail, Phone, MapPin, ExternalLink, FileText } from 'lucide-react';
import { trackPhoneCallConversion } from '@/utils/trackPhoneCall';

const Footer = () => {
  return (
    <footer className="bg-piano-black text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Music className="h-6 w-6 text-piano-gold" />
              <h3 className="text-lg font-serif font-semibold">
                <span className="text-white">Piano</span>
                <span className="text-piano-gold">undervisning</span>
              </h3>
            </div>
            <p className="text-gray-400 mb-4">
              Professionel klaverundervisning for alle niveauer med pianist Oscar Gilbert, uddannet fra Rytmisk Musikkonservatorium.
            </p>
            <a 
              href="https://dk.trustpilot.com/review/oscargilbert.dk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center text-gray-400 hover:text-piano-gold"
            >
              <ExternalLink className="h-4 w-4 mr-2" />
              <span>Se anmeldelser på Trustpilot</span>
            </a>
          </div>
          
          <div>
            <h3 className="text-lg font-serif font-semibold mb-4">Kontaktinformation</h3>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <MapPin className="h-5 w-5 text-piano-gold" />
                <span>Niels Finsens Alle 86, 2860 Søborg</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-5 w-5 text-piano-gold" />
                <a href="mailto:kontakt@pianoundervisning.dk" className="hover:text-piano-gold">
                  kontakt@pianoundervisning.dk
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-5 w-5 text-piano-gold" />
                <a href="tel:+4540817127" className="hover:text-piano-gold" onClick={trackPhoneCallConversion}>
                  +45 40 81 71 27
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-serif font-semibold mb-4">Hurtige Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-piano-gold">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/om" className="text-gray-400 hover:text-piano-gold">
                  Om Oscar
                </Link>
              </li>
              <li>
                <Link to="/undervisning" className="text-gray-400 hover:text-piano-gold">
                  Undervisning
                </Link>
              </li>
              <li>
                <Link to="/lokationer" className="text-gray-400 hover:text-piano-gold">
                  Lokationer
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-piano-gold">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-gray-400 hover:text-piano-gold">
                  Kontakt
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-gray-400 hover:text-piano-gold">
                  Gratis Prøvetime
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-800 text-gray-400 text-sm text-center">
          <p>&copy; {new Date().getFullYear()} Pianoundervisning. CVR: 34814589. Alle rettigheder forbeholdes.</p>
          <div className="mt-2 flex justify-center gap-4">
            <a href="/sitemap.xml" className="inline-flex items-center text-gray-500 hover:text-piano-gold text-xs">
              <FileText className="h-3 w-3 mr-1" />
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
